import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Tab, Nav, Modal, Button, Spinner, Form } from "react-bootstrap";
import { DocumentText, DollarSquare, CardAdd, Judge} from "iconsax-react";
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { sports, italianProvinces, tipologiaStruttura } from "../../../../components/Util/enum";
import { format } from 'date-fns';
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { useProfile } from "../../../../../hooks/useProfile";
import CreateTemporaryPlayerModal from "../../../../components/Clienti/CreateTemporaryPlayerModal";
import { saveSaleDraft, loadSaleDraft, clearSaleDraft } from "../../../../components/Util/saleDraft";
import PrezziPagamento from "../../../../components/Vendite/PrezziPagamento";
import { numeroDaTesto } from "../../../../components/Util/prezzi";

export const UserLessonsNew = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const formRefs = useRef({});
    const [loadingShowed, setLoadingShowed] = useState(false);
    const [juniors, setJuniors] = useState([]);
    const [confirmShowed, setConfirmShowed] = useState(false);
    const [onContinue, setOnContinue] = useState(null);
    const [confirmText, setConfirmText] = useState('');
    const [tabIndex, setTabIndex] = useState(0);
    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [showCreatePlayerModal, setShowCreatePlayerModal] = useState(false);
    const [userSearchInput, setUserSearchInput] = useState("");
    const [isForJunior, setIsForJunior] = useState(false);
    const [termsAndConditions, setTermsAndConditions] = useState(false);
    const [termsAndConditionsMarketing, setTermsAndConditionsMarketing] = useState(false);
    const [termsAndConditionsImage, setTermsAndConditionsImage] = useState(false);
    
    // Nuovi stati per lesson availability
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedSport, setSelectedSport] = useState(null);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [loadingLessons, setLoadingLessons] = useState(false);
    // Si parte dal maestro: le sue lezioni (i prodotti), poi impianto facoltativo, giorno e ore
    const [lezioni, setLezioni] = useState([]);
    const [impianti, setImpianti] = useState([]);
    const [maestro, setMaestro] = useState(null);
    const [selectedVenue, setSelectedVenue] = useState(null);
    const [oraInizio, setOraInizio] = useState('');
    const [oraFine, setOraFine] = useState('');
    const [conflitti, setConflitti] = useState({ maestro: [], impianto: [], controllato: false });
    
    const [formData, setFormData] = useState({
        prezzo_praticato: '',
        playerId: '', 
        juniorId: '',
        selectedDate: '',
        sportType: '',
        lessonId: '',
        slotStartTime: '',
        slotEndTime: '',
        isMember: '',
        isFederated: '',
        corso_user: '',
        corso_user_junior: '',
        tipo_cliente: '',
        ragione_sociale: '',
        partita_iva: '',
        codice_destinatario: '',
        nome: '',
        cognome: '',
        codice_fiscale: '',
        email: '',
        indirizzo: '',
        cap: '',
        citta: '',
        provincia: '',
        nazione: '',
        is_omaggio: false,
        is_pagato: false,
        modalita_pagamento: '',
        skip_generate_document: false
    });

    const { profile, loading: profileLoading } = useProfile();
    const isFatturazioneConfirmed = profile?.club?.invoiceDataSender?.status === 'CONFIRMED';

    useEffect(() => {
        if (!profileLoading && profile && !isFatturazioneConfirmed && formData.skip_generate_document !== true) {
            setFormData(prev => ({ ...prev, skip_generate_document: true }));
        }
    }, [profileLoading, profile, isFatturazioneConfirmed, formData.skip_generate_document]);

    const optionsFatturazione = [
        { value: "privato", label: "Privato" },
        { value: "azienda", label: "Azienda" }
    ];

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ];
    
    const optionsGenerateDocument = [
        { value: false, label: "Si" },
        { value: true, label: "No" }
    ];

    // Funzione helper per formattare le date
    const formatDateWithTime = (date, time) => {
        if (!date || !time) return '';
        try {
            const dateObj = new Date(date);
            const formattedDate = format(dateObj, 'dd/MM/yyyy');
            return `${formattedDate} ${time}`;
        } catch (error) {
            return `${date} ${time}`;
        }
    };

    // Il giorno scritto come lo si legge: «giovedì 25/09/2026»
    const GIORNI = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
    const giornoPerEsteso = (date) => {
        if (!date) return '';
        const d = new Date(`${date}T12:00:00`);
        return isNaN(d) ? String(date) : `${GIORNI[d.getDay()]} ${format(d, 'dd/MM/yyyy')}`;
    };

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (!tokenDetailsString) return;
                const token = JSON.parse(tokenDetailsString).idToken;
                const apiClient = new MyApiClient();
                setLoadingShowed(true);
                const [lezioniApi, impiantiApi] = await Promise.all([
                    apiClient.getBookingLessons(token),
                    apiClient.getVenues(token),
                ]);
                setLoadingShowed(false);
                const elencoLezioni = Array.isArray(lezioniApi) ? lezioniApi : (lezioniApi?.data || []);
                setLezioni(elencoLezioni
                    .filter(l => l.status === 'PURCHASABLE' && l.coachId)
                    .map(l => ({
                        value: l.id,
                        label: l.name,
                        coachId: l.coachId,
                        coachName: l.coachName || l.coachUsername || 'Maestro',
                        sportType: l.sportType,
                        // La programmazione della lezione: si prenota solo dentro questi orari
                        weeklySchedule: Array.isArray(l.weeklySchedule) ? l.weeklySchedule : [],
                    })));
                const elencoImpianti = Array.isArray(impiantiApi) ? impiantiApi : (impiantiApi?.data || impiantiApi?.venues || []);
                setImpianti(elencoImpianti
                    .map(v => ({ value: v.id, label: v.name, sportType: v.sportType }))
                    .sort((a, b) => a.label.localeCompare(b.label)));
            } catch (error) {
                setLoadingShowed(false);
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
        }
    }, []);

    // Precompilazione da querystring (es. dal calendario): lezione, giorno e ore
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const qsDate = params.get('date');
        const qsLessonId = params.get('lessonId');
        const qsStart = params.get('startTime');
        const qsEnd = params.get('endTime');
        if (qsDate) {
            setSelectedDate(qsDate);
            setFormData(prev => ({ ...prev, selectedDate: qsDate }));
        }
        if (qsStart) cambiaOre(qsStart, qsEnd || '');
        if (qsLessonId && lezioni.length > 0) {
            const lezione = lezioni.find(l => String(l.value) === String(qsLessonId));
            if (lezione) {
                setMaestro({ value: lezione.coachId, label: lezione.coachName });
                scegliLezione(lezione);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lezioni, location.search]);

    // Pre-seleziona player da URL params (passato dal calendario)
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const qsPlayerId = params.get('playerId');
        const qsPlayerName = params.get('playerName');
        if (qsPlayerId && qsPlayerName && !formData.playerId) {
            handleUserSelect({ value: qsPlayerId, label: qsPlayerName });
        }
    }, [location.search]);

    const goBack = (numOfTab) => {
        if(numOfTab>-1) {
            setTabIndex(numOfTab);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
        } else {
            navigate('/struttura/booking/lessons');
        }
    };

    // Funzione per la ricerca asincrona degli utenti per il componente Select unificato
    const loadUserOptions = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const playersData = await apiClient.getProfilesByFilters(token, 10000, inputValue, 'IDS_PLAY');

                if (playersData && playersData.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Si è verificato un errore durante la lettura (" + playersData.error + ")");
                    setModalShowed(true);
                    return [];
                } else {
                    const playerOptions = playersData.items.map(element => ({
                        value: element.userId,
                        label: element.name
                    }));
                    return playerOptions;
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            return [];
        }
        return [];
    };

    // Gestisce la selezione dell'utente dal componente Select unificato
    // Cambiando player si azzera quello che apparteneva a quello di prima: junior
    // scelto, suo elenco e dati di fatturazione.
    const handleUserSelect = (selectedOption) => {
        const nuovoId = selectedOption ? selectedOption.value : '';
        const cambiato = nuovoId !== formData.playerId;
        setSelectedUser(selectedOption);
        if (cambiato) {
            setIsForJunior(false);
            setJuniors([]);
        }
        setFormData(prev => (cambiato ? {
            ...prev,
            playerId: nuovoId,
            juniorId: '',
            corso_user_junior: '',
            corso_user: selectedOption ? selectedOption.label : '',
            tipo_cliente: '',
            ragione_sociale: '',
            partita_iva: '',
            codice_destinatario: '',
            nome: '',
            cognome: '',
            codice_fiscale: '',
            email: '',
            indirizzo: '',
            cap: '',
            citta: '',
            provincia: '',
        } : { ...prev, playerId: nuovoId }));
    };

    // Pagina unica: il prezzo e i dati di fatturazione, che nel percorso a passi
    // arrivavano premendo «Avanti», si chiedono appena ci sono cliente e lezione
    // (e lo junior, se serve).
    useEffect(() => {
        if (!formData.playerId || !formData.lessonId) return;
        if (isForJunior && !formData.juniorId) return;
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return;
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        let annullato = false;

        apiClient.getUserBookingLessonsPreview(token, formData.playerId, formData.juniorId, formData.lessonId)
            .then(anteprima => {
                if (annullato || !anteprima?.data) return;
                const d = anteprima.data;
                const italiana = (iso) => (iso ? `${iso.substring(8, 10)}/${iso.substring(5, 7)}/${iso.substring(0, 4)}` : '');
                const r = d.receiver;
                // I dati di fatturazione sono sempre quelli del player scelto: si
                // riscrivono tutti, così cambiando player non restano quelli di prima.
                const fatturazione = r ? {
                    tipo_cliente: r.type === 'business' ? 'azienda' : 'privato',
                    nome: r.type === 'business' ? '' : (r.first_name || ''),
                    cognome: r.type === 'business' ? '' : (r.last_name || ''),
                    ragione_sociale: r.type === 'business' ? (r.denomination || '') : '',
                    partita_iva: r.type === 'business' ? (r.vat_number || '') : '',
                    codice_destinatario: r.type === 'business' ? (r.sdi_code || '') : '',
                    codice_fiscale: r.tax_code || '',
                    email: r.pec || '',
                    indirizzo: r.address || '',
                    cap: r.zip_code || '',
                    citta: r.city || '',
                    provincia: r.province || '',
                } : {};
                setFormData(prev => ({
                    ...prev,
                    lesson_price: d.lessonPrice + ' €',
                    prezzo_praticato: d.lessonPrice,
                    isMember: d.isMember ? 'Si' : 'No',
                    isFederated: d.isFederated ? 'Si' : 'No',
                    dateStart: italiana(d.startDate),
                    dateEnd: italiana(d.endDate),
                    corso_user: selectedUser ? selectedUser.label : prev.corso_user,
                    ...fatturazione,
                }));

                // Senza dati di fatturazione salvati (o senza PEC) si prendono
                // dall'anagrafica del player.
                if (!r || !r.pec) {
                    apiClient.getProfiles(token, formData.playerId).then(playerProfile => {
                        if (annullato || !playerProfile || playerProfile.error) return;
                        const ids = playerProfile.idsPlay || {};
                        const addr = ids.address || {};
                        setFormData(prev => (r
                            ? { ...prev, email: prev.email || ids.email || '' }
                            : {
                                ...prev,
                                tipo_cliente: prev.tipo_cliente || 'privato',
                                nome: ids.givenName || '',
                                cognome: ids.familyName || '',
                                email: ids.email || '',
                                indirizzo: addr.streetAddress || '',
                                cap: addr.postalCode || '',
                                citta: addr.locality || '',
                                provincia: addr.province || '',
                            }));
                    }).catch(errore => console.error('Profilo del player non letto', errore));
                }
            })
            .catch(errore => console.error('Anteprima non riuscita', errore));

        return () => { annullato = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.playerId, formData.lessonId, formData.juniorId, isForJunior]);

    // "Crea nuovo cliente" → pagina completa di creazione, poi ritorno qui col cliente selezionato.
    const goCreateNewCustomer = () => {
        saveSaleDraft(location.pathname, buildDraft());
        const params = new URLSearchParams(location.search);
        ['newCustomerId', 'newCustomerName', 'newJuniorId', 'newJuniorName'].forEach(k => params.delete(k));
        const clean = params.toString();
        const back = location.pathname + (clean ? `?${clean}` : '');
        navigate(`/struttura/clienti/nuovo?returnTo=${encodeURIComponent(back)}`);
    };

    // Al ritorno dalla creazione: ripristina il form e pre-seleziona cliente/junior.
    useEffect(() => {
        const newCustomerId = searchParams.get('newCustomerId');
        const newCustomerName = searchParams.get('newCustomerName');
        const newJuniorId = searchParams.get('newJuniorId');
        const returning = !!(newCustomerId || newJuniorId);
        const draft = returning ? loadSaleDraft(location.pathname) : null;
        clearSaleDraft(location.pathname);

        if (draft) {
            if (draft.formData) setFormData(draft.formData);
            if (draft.selectedUser) setSelectedUser(draft.selectedUser);
            setIsForJunior(!!draft.isForJunior);
            setUserSearchInput(draft.userSearchInput || '');
            setSelectedDate(draft.selectedDate || '');
            setSelectedSport(draft.selectedSport || null);
            setSelectedLesson(draft.selectedLesson || null);
            setSelectedSlot(draft.selectedSlot || null);
            setMaestro(draft.maestro || null);
            setSelectedVenue(draft.selectedVenue || null);
            setOraInizio(draft.oraInizio || '');
            setOraFine(draft.oraFine || '');
            setTermsAndConditions(!!draft.termsAndConditions);
            setTermsAndConditionsMarketing(!!draft.termsAndConditionsMarketing);
            setTermsAndConditionsImage(!!draft.termsAndConditionsImage);
        }

        if (newCustomerId) {
            handleUserSelect({ value: newCustomerId, label: newCustomerName || (draft && draft.selectedUser && draft.selectedUser.label) || 'Cliente' });
            if (newJuniorId) {
                setIsForJunior(true);
                fetchJuniorsFor(newCustomerId).then(list => {
                    setJuniors(list);
                    setFormData(prev => ({ ...prev, juniorId: newJuniorId }));
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => {
            const newData = {
                ...prev,
                [name]: selectedValue,
            };
            
            // Se is_pagato viene impostato su false, resetta anche skip_generate_document
            if (name === 'is_pagato' && !selectedValue) {
                newData.skip_generate_document = (profile && !isFatturazioneConfirmed) ? true : false;
            }
            
            return newData;
        });
    };

    // I maestri sono quelli che hanno almeno una lezione acquistabile
    const maestri = Object.values(lezioni.reduce((acc, l) => {
        if (!acc[l.coachId]) acc[l.coachId] = { value: l.coachId, label: l.coachName };
        return acc;
    }, {})).sort((a, b) => a.label.localeCompare(b.label));
    const lezioniDelMaestro = maestro ? lezioni.filter(l => l.coachId === maestro.value) : [];

    const scegliLezione = (lezione) => {
        setSelectedLesson(lezione);
        setSelectedSport(lezione ? { value: lezione.sportType } : null);
        setFormData(prev => ({
            ...prev,
            lessonId: lezione ? lezione.value : '',
            sportType: lezione ? lezione.sportType : '',
            course_name: lezione ? lezione.label : '',
        }));
    };

    // Scelto il maestro: se ha una sola lezione è quella, altrimenti si sceglie
    const scegliMaestro = (opzione) => {
        setMaestro(opzione);
        const sue = opzione ? lezioni.filter(l => l.coachId === opzione.value) : [];
        scegliLezione(sue.length === 1 ? sue[0] : null);
    };

    // Oggi in formato aaaa-mm-gg: il primo giorno prenotabile
    const oggi = (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; })();
    // Giorno completo e da oggi in avanti: solo allora si leggono orari e prenotazioni
    const giornoValido = /^\d{4}-\d{2}-\d{2}$/.test(selectedDate || '') && selectedDate >= oggi;
    const [giornoPassato, setGiornoPassato] = useState(false);

    const handleDateChange = (event) => {
        const date = event.target.value;
        // Mentre si scrive l'anno passa per valori come 0002, 0020, 0202: il giorno si
        // accetta com'è, il controllo del passato si fa uscendo dal campo e alla conferma.
        setGiornoPassato(false);
        setSelectedDate(date);
        setFormData(prev => ({ ...prev, selectedDate: date }));
    };

    // Le ore: la fine si propone un'ora dopo l'inizio, finché non la si cambia
    const piuUnOra = (ora) => {
        const [h, m] = ora.split(':').map(Number);
        const tot = Math.min(h * 60 + m + 60, 23 * 60 + 59);
        return `${String(Math.floor(tot / 60)).padStart(2, '0')}:${String(tot % 60).padStart(2, '0')}`;
    };
    const cambiaOre = (inizio, fine) => {
        setOraInizio(inizio);
        setOraFine(fine);
        setSelectedSlot(inizio && fine ? { startTime: inizio, endTime: fine } : null);
        setFormData(prev => ({ ...prev, slotStartTime: inizio, slotEndTime: fine }));
    };

    // Controllo delle prenotazioni: il maestro e (se scelto) l'impianto in quel giorno e orario
    useEffect(() => {
        if (!maestro || !giornoValido || !oraInizio || !oraFine || oraFine <= oraInizio) {
            setConflitti({ maestro: [], impianto: [], controllato: false });
            return;
        }
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return;
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        const da = `${selectedDate}T00:00:00`;
        const a = `${selectedDate}T23:59:59`;
        const inizioMs = new Date(`${selectedDate}T${oraInizio}:00`).getTime();
        const fineMs = new Date(`${selectedDate}T${oraFine}:00`).getTime();
        const sovrapposti = (dati) => (Array.isArray(dati?.eventi) ? dati.eventi : [])
            .filter(e => new Date(e.dataInizio).getTime() < fineMs && new Date(e.dataFine).getTime() > inizioMs);
        let annullato = false;
        const tipi = 'impianto,lezione,corso';
        Promise.all([
            apiClient.getCalendarioEventi(token, da, a, { maestri: maestro.value, tipi }),
            selectedVenue ? apiClient.getCalendarioEventi(token, da, a, { impianti: selectedVenue.value, tipi }) : Promise.resolve(null),
        ]).then(([delMaestro, dellImpianto]) => {
            if (annullato) return;
            setConflitti({
                maestro: sovrapposti(delMaestro),
                impianto: selectedVenue ? sovrapposti(dellImpianto) : [],
                controllato: !delMaestro?.error && !dellImpianto?.error,
            });
        }).catch(errore => console.error('Controllo prenotazioni non riuscito', errore));
        return () => { annullato = true; };
    }, [maestro, selectedVenue, selectedDate, giornoValido, oraInizio, oraFine]);

    const oraDi = (iso) => {
        const d = new Date(iso);
        return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };
    const occupato = conflitti.maestro.length > 0 || conflitti.impianto.length > 0;

    /*
     * La programmazione settimanale della lezione (es. lunedì 10–11): il giorno e le ore scelti
     * devono starci dentro. Il server oggi non lo controlla, quindi senza questo si potevano
     * prenotare lezioni in giorni e orari in cui non sono previste.
     */
    const GIORNI_SERVER = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    const programma = selectedLesson?.weeklySchedule || [];
    const programmaLeggibile = programma
        .slice()
        .sort((a, b) => ((GIORNI_SERVER.indexOf(a.dayOfWeek) + 6) % 7) - ((GIORNI_SERVER.indexOf(b.dayOfWeek) + 6) % 7) || a.startTime.localeCompare(b.startTime))
        .map(p => `${GIORNI[GIORNI_SERVER.indexOf(p.dayOfWeek)] || p.dayOfWeek} ${p.startTime}–${p.endTime}`)
        .join(', ');
    const giornoSettimana = giornoValido ? GIORNI_SERVER[new Date(`${selectedDate}T12:00:00`).getDay()] : '';
    const orariDelGiorno = programma.filter(p => p.dayOfWeek === giornoSettimana);
    const fuoriProgramma = !!(selectedLesson && programma.length > 0 && giornoValido && oraInizio && oraFine && oraFine > oraInizio
        && !orariDelGiorno.some(p => oraInizio >= p.startTime && oraFine <= p.endTime));

    const handleCheckboxChangeTermsAndConditions = (event) => {
        setTermsAndConditions(event.target.checked);
    };

    const handleCheckboxChangeTermsAndConditionsMarketing = (event) => {
        setTermsAndConditionsMarketing(event.target.checked);
    };

    const handleCheckboxChangeTermsAndConditionsImage = (event) => {
        setTermsAndConditionsImage(event.target.checked);
    };

    // Carica i junior di un cliente (parent) e li mappa per la Lista Juniors.
    const fetchJuniorsFor = async (playerId) => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) return [];
            const token = JSON.parse(tokenDetailsString).idToken;
            const apiClient = new MyApiClient();
            const juniorsData = await apiClient.getJuniorsByParent(token, playerId);
            const data = [];
            if (juniorsData) {
                juniorsData.forEach(element => {
                    let status = null;
                    if (element.profileStatus === 'INACTIVE') status = { label: 'Inattivo', class: 'text-danger' };
                    else if (element.profileStatus === 'ACTIVE') status = { label: 'Attivo', class: 'text-warning' };
                    else if (element.profileStatus === 'COMPLETED') status = { label: 'Completato', class: 'text-success' };
                    data.push({
                        registration_date: format(element.createdAt, 'dd/MM/yyyy HH:mm:ss'),
                        id: element.userId,
                        nome: element.givenName,
                        cognome: element.familyName,
                        status_label: status,
                    });
                });
            }
            return data;
        } catch (error) {
            console.error('Error fetching juniors:', error);
            return [];
        }
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsForJunior(checked);
        if (checked && formData.playerId !== '') {
            setLoadingShowed(true);
            fetchJuniorsFor(formData.playerId).then(list => {
                setLoadingShowed(false);
                setJuniors(list);
            });
        } else {
            setIsForJunior(false);
            setJuniors([]);
            setFormData(prev => ({ ...prev, juniorId: '' }));
        }
    };

    // Snapshot di tutto ciò che l'utente ha inserito, per ripristinarlo al ritorno.
    const buildDraft = () => ({
        formData,
        selectedUser,
        isForJunior,
        userSearchInput,
        selectedDate,
        selectedSport,
        selectedLesson,
        selectedSlot,
        maestro,
        selectedVenue,
        oraInizio,
        oraFine,
        termsAndConditions,
        termsAndConditionsMarketing,
        termsAndConditionsImage,
    });

    // "Aggiungi Junior" → pagina di creazione junior (parent = cliente selezionato), poi ritorno qui col junior selezionato.
    const goCreateNewJunior = () => {
        if (!formData.playerId) return;
        saveSaleDraft(location.pathname, buildDraft());
        const params = new URLSearchParams(location.search);
        ['newCustomerId', 'newCustomerName', 'newJuniorId', 'newJuniorName'].forEach(k => params.delete(k));
        params.set('newCustomerId', formData.playerId);
        params.set('newCustomerName', selectedUser?.label || '');
        const back = location.pathname + '?' + params.toString();
        const pName = selectedUser?.label || '';
        navigate(`/struttura/junior/nuovo?parentId=${encodeURIComponent(formData.playerId)}&parentName=${encodeURIComponent(pName)}&returnTo=${encodeURIComponent(back)}`);
    };

    const juniors_data_column = [
        {
            // La scelta sta nella prima colonna e resta segnata: un solo junior alla volta
            Header: '',
            accessor: 'scelta',
            disableFilters: true,
            disableGlobalFilter: true,
            Cell: ({ row }) => {
                const scelto = formData.juniorId === row.original.id;
                return (
                    <input
                        type="radio"
                        name="juniorScelto"
                        checked={scelto}
                        onChange={() => setFormData(prev => ({
                            ...prev,
                            juniorId: row.original.id,
                            corso_user_junior: `${row.original.nome} ${row.original.cognome}`,
                        }))}
                    />
                );
            },
        },
        {
            Header: 'Nome e cognome',
            accessor: 'name',
            Cell: ({ row }) => row.original.nome + ' ' + row.original.cognome,
        },
        {
            Header: 'Data registrazione',
            accessor: 'registration_date',
        },
        {
            Header: 'Stato',
            Footer: 'Stato',
            accessor: 'status_label',
            disableFilters: true,
            Cell: ({ value }) => (
                <div className="d-flex align-items-center">
                    <i className={`fa fa-circle me-1 ${value ? value.class : ''}`}></i>
                    {value ? value.label : ''}
                </div>
            ),
        },
    ];

    /** Conferma dalla pagina unica: controlla tutti i riquadri, poi salva. */
    const confermaAcquisto = () => {
        if (!maestro || !selectedLesson || !giornoValido || !oraInizio || !oraFine) {
            setModalTitle('Manca la prenotazione');
            setModalText('Scegli il maestro, la lezione, un giorno da oggi in avanti e le ore di inizio e fine.');
            setModalShowed(true);
            return;
        }
        if (oraFine <= oraInizio) {
            setModalTitle('Controlla le ore');
            setModalText("L'ora di fine deve essere dopo l'ora di inizio.");
            setModalShowed(true);
            return;
        }
        if (fuoriProgramma) {
            setModalTitle('Fuori programma');
            setModalText(`«${selectedLesson.label}» è in programma ${programmaLeggibile}: scegli un giorno e delle ore compresi in quegli orari.`);
            setModalShowed(true);
            return;
        }
        if (occupato) {
            setModalTitle(conflitti.maestro.length ? 'Maestro occupato' : 'Impianto occupato');
            setModalText('In quel giorno e orario ci sono già altre prenotazioni: cambia orario, giorno o impianto.');
            setModalShowed(true);
            return;
        }
        if (isForJunior && !formData.juniorId) {
            setModalTitle('Devi selezionare uno junior');
            setModalText("Se l'acquisto è per uno junior devi selezionare il junior dalla lista");
            setModalShowed(true);
            return;
        }
        for (const form of Object.values(formRefs.current)) {
            if (!form) continue;
            // Partita IVA e codice fiscale hanno un formato loro: il browser da solo
            // non li controlla, glielo diciamo qui.
            for (const campo of form.elements) {
                if (campo.name === 'partita_iva') {
                    campo.setCustomValidity(
                        campo.value && (campo.value.length !== 11 || isNaN(campo.value))
                            ? 'La partita IVA deve contenere esattamente 11 cifre numeriche.'
                            : '');
                }
                if (campo.name === 'codice_fiscale' && campo.value) {
                    const cfRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
                    const valido = (campo.value.length === 16 && cfRegex.test(campo.value))
                        || (campo.value.length === 11 && !isNaN(campo.value));
                    campo.setCustomValidity(valido ? '' : 'Controlla il formato del codice fiscale (16 caratteri) o della partita IVA (11 cifre)');
                }
            }
            if (!form.checkValidity()) {
                form.reportValidity();
                return;
            }
        }
        handleSaveClick(4, 'PURCHASABLE');
    };

    /** Salvataggio: percorso unico, la pagina è una sola. */
    const handleSaveClick = (numOfTab, status) => {
        if(!termsAndConditions) {
            setModalTitle("Devi accettare i termini e condizioni");
            setModalText("Per poter procedere il cliente deve accettare Termini e Condizioni delle strutture SportId verso i Player.");
            setModalShowed(true);
            return;
        }
        
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            formData.clubId = tokenDetails.localId;
            formData.status = status;
            saveConfirm();
        }
    };

    const saveConfirm = () => {
        setOnContinue(() => () => saveData());
        setConfirmShowed(true);
        setConfirmText("Sei sicuro di volere continuare? Ricorda che ogni acquisto sarà effettivo solo nel momento in cui risulta pagato.");
    };

    const saveData = async () => {

        setConfirmShowed(false);

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const userConsents = [];
                userConsents.push({
                    playerId: formData.playerId,
                    juniorId: formData.juniorId !== '' ? formData.juniorId :  undefined,
                    clubId: tokenDetails.localId,
                    consentType: 'PHOTO_USAGE_BY_STRUCTURE',
                    consent: termsAndConditionsMarketing
                });
                userConsents.push({
                    playerId: formData.playerId,
                    juniorId: formData.juniorId !== '' ? formData.juniorId :  undefined,
                    clubId: tokenDetails.localId,
                    consentType: 'MARKETING_BY_STRUCTURE',
                    consent: termsAndConditionsImage
                });

                const saveData = {
                    playerId: formData.playerId,
                    lesson_id: formData.lessonId,
                    clubId: formData.clubId,
                    price: formData.prezzo_praticato === '' ? undefined : numeroDaTesto(formData.prezzo_praticato),
                    userConsents: userConsents,
                    bookingDate: selectedDate,
                    startTime: selectedSlot ? selectedSlot.startTime : "",
                    endTime: selectedSlot ? selectedSlot.endTime : "",
                }
                // Impianto facoltativo: il backend lo registra quando lo prevede (venueId)
                if(selectedVenue) saveData.venueId = selectedVenue.value;

                if(formData.juniorId) saveData.juniorId = formData.juniorId;
                // Omaggio: il motivo resta sull'acquisto, nel campo nota
                if(formData.is_omaggio && formData.nota_omaggio) {
                    saveData.note = formData.nota_omaggio;
                }
                // L'omaggio viaggia come le altre forme di pagamento: e' il backend a
                // sapere che chiude a zero e non emette documento.
                if(formData.is_pagato && formData.modalita_pagamento) {
                    saveData.payment_method = formData.modalita_pagamento;
                    saveData.paymentDate = new Date().toISOString().slice(0, 10);
                }
                if(formData.skip_generate_document) {
                    saveData.skip_generate_document = true;
                }

                const dati_fatturazione = {
                    tax_code: formData.codice_fiscale,
                    pec: formData.email,
                    address: formData.indirizzo,
                    zip_code: formData.cap,
                    city: formData.citta,
                    province: formData.provincia,
                    nation: 'IT',
                    country_code: 'IT',
                }
                if(formData.tipo_cliente === 'privato') {
                    dati_fatturazione.type = 'consumer';
                    dati_fatturazione.first_name = formData.nome;
                    dati_fatturazione.last_name = formData.cognome;
                } else if(formData.tipo_cliente === 'azienda') {
                    dati_fatturazione.type = 'business';
                    dati_fatturazione.denomination = formData.ragione_sociale;
                    dati_fatturazione.vat_number = formData.partita_iva;
                    dati_fatturazione.sdi_code = formData.codice_destinatario;
                }

                saveData.receiver = dati_fatturazione;

                setLoadingShowed(true);
                const result = await apiClient.createUserBookingLesson(token, saveData);
                setLoadingShowed(false);

                if(result && result.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText(result.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/sales');
                }
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }   
    }

    const tabData = [
        {
            id: 'informazioni_generali',
            name: "Informazioni generali",
            icon: <i className="fas fa-info-circle me-2"></i>,
            content: (
                <>
                    <Card>
                        <Card.Body>
                            <Form ref={el => formRefs.current[0] = el} noValidate>
                                {/* Prima il maestro, poi (se ne ha più d'una) la lezione, l'impianto se serve,
                                    il giorno e le ore. Le prenotazioni già presenti si controllano subito. */}
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Label>Maestro</Form.Label>
                                        <Select
                                            placeholder="Scegli il maestro..."
                                            name="coachId"
                                            value={maestro}
                                            onChange={scegliMaestro}
                                            options={maestri}
                                            noOptionsMessage={() => 'Nessun maestro con lezioni in vendita'}
                                            className="mt-2"
                                        />
                                    </Col>
                                    {lezioniDelMaestro.length > 1 && (
                                        <Col md={6}>
                                            <Form.Label>Lezione</Form.Label>
                                            <Select
                                                placeholder="Scegli la lezione..."
                                                name="lessonId"
                                                value={selectedLesson}
                                                onChange={scegliLezione}
                                                options={lezioniDelMaestro}
                                                className="mt-2"
                                            />
                                        </Col>
                                    )}
                                    {lezioniDelMaestro.length === 1 && (
                                        <Col md={6}>
                                            <Form.Label>Lezione</Form.Label>
                                            <div className="sid-readonly-value sid-readonly-value--campo">{lezioniDelMaestro[0].label}</div>
                                        </Col>
                                    )}
                                </Row>

                                {maestro && (
                                    <Row className="g-4 mt-0">
                                        <Col md={6}>
                                            <Form.Label>Impianto <span className="sid-facoltativo">facoltativo</span></Form.Label>
                                            <Select
                                                placeholder="Nessun impianto"
                                                name="venueId"
                                                value={selectedVenue}
                                                onChange={setSelectedVenue}
                                                options={impianti}
                                                isClearable
                                                className="mt-2"
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Form.Label htmlFor="selectedDate">Giorno</Form.Label>
                                            <Form.Control
                                                id="selectedDate"
                                                className="mt-2"
                                                type="date"
                                                name="selectedDate"
                                                value={selectedDate}
                                                min={oggi}
                                            onBlur={() => setGiornoPassato(!!selectedDate && !giornoValido)}
                                                onChange={handleDateChange}
                                                required
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Form.Label htmlFor="oraInizio">Ora di inizio</Form.Label>
                                            <Form.Control
                                                id="oraInizio"
                                                className="mt-2"
                                                type="time"
                                                step="900"
                                                value={oraInizio}
                                                onChange={e => cambiaOre(e.target.value, (!oraFine || oraFine === piuUnOra(oraInizio || '00:00')) && e.target.value ? piuUnOra(e.target.value) : oraFine)}
                                                required
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Form.Label htmlFor="oraFine">Ora di fine</Form.Label>
                                            <Form.Control
                                                id="oraFine"
                                                className="mt-2"
                                                type="time"
                                                step="900"
                                                min={oraInizio || undefined}
                                                value={oraFine}
                                                onChange={e => cambiaOre(oraInizio, e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                )}

                                {giornoPassato && (
                                    <div className="sid-avviso is-errore mt-3">Si può prenotare da oggi in avanti: scegli un giorno a partire da oggi.</div>
                                )}
                                {oraInizio && oraFine && oraFine <= oraInizio && (
                                    <div className="sid-avviso is-errore mt-3">L&apos;ora di fine deve essere dopo l&apos;ora di inizio.</div>
                                )}
                                {selectedLesson && programmaLeggibile && !fuoriProgramma && (
                                    <div className="text-muted small mt-2">In programma: {programmaLeggibile}.</div>
                                )}
                                {fuoriProgramma && (
                                    <div className="sid-avviso is-errore mt-3">
                                        <b>Fuori dalla programmazione della lezione</b>: «{selectedLesson.label}» è in programma {programmaLeggibile}.
                                        {orariDelGiorno.length === 0 ? ` ${giornoPerEsteso(selectedDate)} non è prevista.` : ' Scegli ore comprese in quegli orari.'}
                                    </div>
                                )}
                                {conflitti.maestro.length > 0 && (
                                    <div className="sid-avviso is-errore mt-3">
                                        <b>{maestro.label} è già occupato</b> {giornoPerEsteso(selectedDate)}:{' '}
                                        {conflitti.maestro.map(e => `${oraDi(e.dataInizio)}–${oraDi(e.dataFine)} (${e.titolo})`).join(', ')}.
                                    </div>
                                )}
                                {conflitti.impianto.length > 0 && (
                                    <div className="sid-avviso is-errore mt-3">
                                        <b>{selectedVenue.label} è già occupato</b> {giornoPerEsteso(selectedDate)}:{' '}
                                        {conflitti.impianto.map(e => `${oraDi(e.dataInizio)}–${oraDi(e.dataFine)} (${e.titolo})`).join(', ')}.
                                    </div>
                                )}
                                {conflitti.controllato && !occupato && !fuoriProgramma && (
                                    <div className="sid-avviso is-ok mt-3">
                                        {selectedVenue ? `${maestro.label} e ${selectedVenue.label} sono liberi` : `${maestro.label} è libero`} {giornoPerEsteso(selectedDate)} dalle {oraInizio} alle {oraFine}.
                                    </div>
                                )}
                                <div className="sid-gen-panel mt-4">
                                    <div className="sid-gen-panel__titolo">Chi partecipa</div>
                                    <p className="sid-gen-panel__aiuto">
                                        Scegli il cliente, oppure creane uno nuovo. Lo junior si può indicare <b>solo dopo aver scelto il
                                        cliente</b>: i suoi junior compaiono qui sotto.
                                    </p>
                                    <Row className="g-4">
                                        <Col md={9}>
    										<Form.Label>Cerca e seleziona un utente di SportId</Form.Label>
                                                <CreateTemporaryPlayerModal
                                                    show={showCreatePlayerModal}
                                                    onHide={() => setShowCreatePlayerModal(false)}
                                                    initialName={userSearchInput}
                                                    onCreated={(player) => { handleUserSelect(player); setShowCreatePlayerModal(false); }}
                                                />
    										<AsyncSelect
                                                    required
                                                    name="playerId"
                                                    value={selectedUser}
                                                    onChange={handleUserSelect}
                                                    onInputChange={(value, meta) => { if (meta.action === 'input-change') setUserSearchInput(value); }}
                                                    loadOptions={loadUserOptions}
                                                    placeholder="Inizia a digitare per cercare un utente (minimo 3 caratteri)..."
                                                    noOptionsMessage={({ inputValue }) => 
                                                        inputValue.length < 3 
                                                            ? "Digita almeno 3 caratteri per iniziare la ricerca" 
                                                            : "Nessun utente trovato"
                                                    }
                                                    loadingMessage={() => "Ricerca in corso..."}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions={false}
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            minHeight: "38px",
                                                            height: "38px",
                                                            border: "1px solid #ced4da",
                                                            borderRadius: "0.375rem",
                                                            fontSize: "0.9rem",
                                                            lineHeight: "1.5"
                                                        }),
                                                        valueContainer: (provided) => ({
                                                            ...provided,
                                                            height: "36px",
                                                            padding: "0 8px"
                                                        }),
                                                        input: (provided) => ({
                                                            ...provided,
                                                            margin: "0",
                                                            paddingTop: "0",
                                                            paddingBottom: "0"
                                                        }),
                                                        indicatorsContainer: (provided) => ({
                                                            ...provided,
                                                            height: "36px"
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: "#6c757d",
                                                            fontSize: "0.9rem"
                                                        })
                                                    }}
                                                />
                                        </Col>
                                        <Col md={3} className="d-flex align-items-end justify-content-end">
                                            <Button variant="outline-dark" size="sm" onClick={goCreateNewCustomer}>
                                                + Crea nuovo player
                                            </Button>
                                        </Col>
                                        <Col md={12} className="mt-2">
                                            <Form ref={el => formRefs.current[1] = el} noValidate>
                                        <Row>
                                            <label>
                                                <input
                                                type="checkbox"
                                                checked={isForJunior}
                                                onChange={handleCheckboxChange}
                                                />
                                                &nbsp;&nbsp;&nbsp;Questa lezione viene acquistata per uno junior
                                            </label>
                                        </Row>
    
                                        {isForJunior && (
                                            <>
                                                {formData.playerId && (
                                                    <div className="mb-2 mt-2">
                                                        <Button variant="link" className="p-0" style={{ fontSize: "0.9rem" }} onClick={goCreateNewJunior}>
                                                            Assegna junior
                                                        </Button>
                                                    </div>
                                                )}
                                                {juniors && juniors.length > 0 ? (
                                                    <TabellaLista
                                                        cardTitle={'Lista Juniors'}
                                                        hasSearch={false}
                                                        hasFilter={false}
                                                        data_column={juniors_data_column}
                                                        data_json={juniors}
                                                        notPagination={true}
                                                        hasAddMoreAsModal={false}
                                                    />
                                                ) : (
                                                    <p className="text-muted mt-2">Nessun junior collegato a questo cliente. Usa "Assegna junior" per crearne uno.</p>
                                                )}
                                            </>
                                        )}
                                            </Form>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </>
            ),
        },
        {
            id: 'prezzi',
            name: "Prezzi",
            icon: <DollarSquare size='18' />,
            content: (
                <>
                    <PrezziPagamento
                        formData={formData}
                        setFormData={setFormData}
                        listino={formData.lesson_price}
                        isFatturazioneConfirmed={isFatturazioneConfirmed}
                        formRef={el => formRefs.current[3] = el}
                    />
                </>
            ),
        },
        {
            id: 'fatturazione_pagamento',
            name: "Fatturazione e pagamento",
            icon: <CardAdd size='18' />,
            content: (
                <>
                    <Form ref={el => formRefs.current[2] = el} noValidate>
                        <Card>
                            <Card.Header><h4 className="card-title">Dati di fatturazione</h4></Card.Header>
                            <Card.Body>        
                                <Row className="mt-4">
                                    {/* Selezione Tipo Cliente */}
                                    <Col md={12}>
                                        <Form.Label>Tipo Cliente</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            name="tipo_cliente"
                                            value={optionsFatturazione.find(option => option.value === formData.tipo_cliente)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "tipo_cliente")} 
                                            options={optionsFatturazione}
                                        />
                                    </Col>
                                </Row>

                                {/* Azienda */}
                                {formData.tipo_cliente === 'azienda' && (
                                    <Row className="mt-4">
                                        <Col lg={4}>
                                            <Form.Label>Ragione sociale</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="ragione_sociale"
                                                value={formData.ragione_sociale}
                                                onChange={e => setFormData(prev => ({ ...prev, ragione_sociale: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Form.Label>Partita IVA</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="partita_iva"
                                                value={formData.partita_iva}
                                                onChange={e => setFormData(prev => ({ ...prev, partita_iva: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Form.Label>Codice Destinatario (SDI)</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="codice_destinatario"
                                                value={formData.codice_destinatario}
                                                onChange={e => setFormData(prev => ({ ...prev, codice_destinatario: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>
                                )}

                                {/* Privato */}
                                {formData.tipo_cliente === 'privato' && (
                                    <Row className="mt-4">
                                        <Col lg={6}>
                                            <Form.Label>Nome</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="nome"
                                                value={formData.nome}
                                                onChange={e => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Label>Cognome</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="cognome"
                                                value={formData.cognome}
                                                onChange={e => setFormData(prev => ({ ...prev, cognome: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>
                                )}

                                {/* Campi comuni */}
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Codice Fiscale</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="codice_fiscale"
                                            value={formData.codice_fiscale}
                                            onChange={e => setFormData(prev => ({ ...prev, codice_fiscale: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Email PEC / Email</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Indirizzo</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="indirizzo"
                                            value={formData.indirizzo}
                                            onChange={e => setFormData(prev => ({ ...prev, indirizzo: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Label>CAP</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="cap"
                                            value={formData.cap}
                                            onChange={e => setFormData(prev => ({ ...prev, cap: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Label>Città</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="citta"
                                            value={formData.citta}
                                            onChange={e => setFormData(prev => ({ ...prev, citta: e.target.value }))}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Provincia</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            name="provincia"
                                            value={italianProvinces.find(option => option.value === formData.provincia)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "provincia")} 
                                            options={italianProvinces}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Nazione</Form.Label>
                                        <Form.Control
                                            required
                                            readOnly
                                            className="mt-2"
                                            type="text"
                                            name="nazione"
                                            value="Italia"
                                            onChange={e => setFormData(prev => ({ ...prev, nazione: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Form>
                </>
            ),
        },
        {
            id: 'riepilogo',
            name: "Consensi",
            icon: <Judge size='18' />,
            content: (
                <>
                    <Card>
                        <Card.Header><h4 className="card-title">Consensi</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Row>
                                    <label>
                                        <input
                                        type="checkbox"
                                        checked={termsAndConditions}
                                        onChange={handleCheckboxChangeTermsAndConditions}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Il cliente accetta <a style={{ color: 'var(--primary)' }} target="_blank" href="https://sportid.it/termini-e-condizioni/strutture-e-player/" rel="noreferrer">termini e condizioni della struttura</a></b>
                                    </label>
                                </Row>
                                <Row>
                                    <label>
                                        <input
                                        type="checkbox"
                                        checked={termsAndConditionsMarketing}
                                        onChange={handleCheckboxChangeTermsAndConditionsMarketing}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Attività di marketing</b><br></br>
                                        Autorizzo il centro sportivo a inviarmi comunicazioni promozionali relative a eventi, corsi, 
                                        offerte e iniziative tramite email, SMS o altri canali.
                                    </label>
                                </Row>
                                <Row>
                                    <label>
                                        <input
                                        type="checkbox"
                                        checked={termsAndConditionsImage}
                                        onChange={handleCheckboxChangeTermsAndConditionsImage}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Uso dell'immagine</b><br></br>
                                        Autorizzo il centro sportivo all’utilizzo di foto e video in cui potrei comparire, realizzati durante le attività, 
                                        per finalità informative, promozionali e di comunicazione sui canali ufficiali (sito web, social media, materiali informativi), 
                                        nel rispetto della normativa sulla privacy (Reg. UE 2016/679 - GDPR).
                                    </label>
                                </Row>
                            </Row>
                        </Card.Body>
                    </Card>
                </>
            ),
        }
    ];

    return (
        <>
            <Modal className="fade" show={confirmShowed} centered>
                <Modal.Header>
                    <Modal.Title>Sei sicuro?</Modal.Title>
                    <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{confirmText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                        Chiudi
                    </Button>
                    <Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                        Continua
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
                <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            <div className="custom-tab-1">
                {/* Pagina unica: le sezioni del vecchio percorso a passi, una sotto l'altra. */}
                <Row className="align-items-start">
                    <div className="col-12">
                        {tabData.map((data, i) => (
                            <div key={data.id} className={i > 0 ? 'mt-4' : undefined}>
                                {data.content}
                            </div>
                        ))}
                        {/* I tasti chiudono la colonna dei riquadri, a destra sul loro bordo. */}
                        <div className="d-flex justify-content-end gap-4 mt-4">
                            <button type="button" className="btn btn-dark light" onClick={() => goBack(-1)}>Annulla</button>
                            <Button className="btn btn-primary" onClick={confermaAcquisto}>Conferma</Button>
                        </div>
                    </div>
                </Row>
            </div>

        </>
    )

}
export default UserLessonsNew;